/**
 * @generated SignedSource<<3902b07ebd67a0b3cbf092c1d6ea3a35>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type Nav4Operations$data = {
  readonly " $fragmentSpreads": FragmentRefs<"OperationsMenuForLanding">;
  readonly " $fragmentType": "Nav4Operations";
};
export type Nav4Operations$key = {
  readonly " $data"?: Nav4Operations$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Operations">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isOperationsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Operations",
  "selections": [
    {
      "condition": "isOperationsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "OperationsMenuForLanding"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "1d297012078c362907ac313c8068c25a";

export default node;
